import React, { useState } from 'react';
import SearchPage from './pages/SearchPage';
import ResultsPage from './pages/ResultsPage';
import { API_ENDPOINTS } from './utils/config';

function App() {
  const [results, setResults] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [loading, setLoading] = useState(false);

  const performSearch = async (registration) => {
    setLoading(true);
    setSearchQuery(registration);
    try {
      // Try MOT history first (for UK vehicles)
      const response = await fetch(API_ENDPOINTS.MOT_HISTORY(registration), {
        method: 'GET',
        headers: { 'Accept': 'application/json' }
      });
      
      if (response.ok) {
        // UK vehicle found in MOT database
        const data = await response.json();

        console.log('Setting results with MOT data:', data);
        setResults(data);
      } else {
        // If MOT fails, try v2 endpoint (handles both UK and Dutch)
	const v2Response = await fetch(API_ENDPOINTS.SMART_VEHICLE(registration), {
          method: 'GET',
          headers: { 'Accept': 'application/json' }
        });
        const v2Text = await v2Response.text();
        let v2Data;
        try {
          v2Data = JSON.parse(v2Text);
        } catch (parseErr) {
          v2Data = {
            error: 'Service unavailable',
            message:
              v2Response.status === 403
                ? 'Vehicle lookup is temporarily unavailable. The DVLA service is being reactivated — please try again later.'
                : v2Response.status === 502 || v2Response.status === 503
                ? 'Vehicle lookup service is temporarily down. Please try again shortly.'
                : `Service error (${v2Response.status}). Please try again.`
          };
        }
        console.log('Setting results with v2 data:', v2Data);
        if (!v2Response.ok) {
          throw new Error(v2Data.error || v2Data.message || 'Vehicle not found');
        }
        setResults(v2Data);
      }
    } catch (err) {
     
 console.error('Search error:', err); 
     throw err;
    } finally {
      setLoading(false);
    }
  };

  const handleBack = () => {
    setResults(null);
    setSearchQuery('');
  };

  return (
    <div className="App">
      {!results ? (
        <SearchPage
          onSearch={performSearch}
          loading={loading}
        />
      ) : (
        <ResultsPage
          results={results}
          searchQuery={searchQuery}
          onBack={handleBack}
        />
      )}
    </div>
  );
}

export default App;
